module.exports = {
      id: "ic-otc-normal-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-otc-normal-usage",
      toString: function () {
        return this.url;
      }
    }